// Runtime environment for the web bundle (also used inside apps/desktop).

/** API origin; '' = same origin. See vite-env.d.ts. */
export const API_BASE_URL = (import.meta.env.VITE_PUBLIC_API_URL ?? '').replace(/\/$/, '');

/**
 * Origin of the human-check page (apps/challenge). It must differ from this
 * app's origin: that difference is what keeps Turnstile away from secrets.
 * Dev falls back to `pnpm --filter @sss/challenge dev`.
 */
export const CHALLENGE_URL = (import.meta.env.VITE_PUBLIC_CHALLENGE_URL ?? (import.meta.env.DEV ? 'http://localhost:8789' : '')).replace(/\/$/, '');

/** True when running inside the Electron wrapper (apps/desktop). */
export const isElectron = typeof window !== 'undefined' && Boolean(window.electronAPI);

/**
 * ICE servers for live handoff's direct connections (docs/adr/0010). STUN
 * only tells a browser its public address; nothing is relayed through it.
 */
export const ICE_SERVERS: RTCIceServer[] = (import.meta.env.VITE_PUBLIC_STUN_URLS ?? 'stun:stun.cloudflare.com:3478')
  .split(',')
  .map((url) => url.trim())
  .filter(Boolean)
  .map((urls) => ({ urls }));
